// addressSlice.js

import { createSlice } from '@reduxjs/toolkit';

const addressSlice = createSlice({
  name: 'address',
  initialState: {
    defaultAddressId: null,
  },
  reducers: {
    setDefaultAddress: (state, action) => {
      state.defaultAddressId = action.payload;
    },
  },
});

export const { setDefaultAddress } = addressSlice.actions;
export default addressSlice.reducer;
